import T from "utils/T";

const DAY_ZONE_TYPES = [
  T('새벽'),
  T('오전'),
  T('오후'),
  T('저녁'),
];

export default DAY_ZONE_TYPES;